import React, { useEffect, useState } from 'react';
import styles from './correctStatus.css';
import { useSelector } from 'react-redux';

/***********************************************************************************************************************
 *
 * @param content
 * @param setEventSound
 * @param status
 * @returns {*}
 * @constructor
 **********************************************************************************************************************/

const CorrectStatus = React.memo(( { setEventSound, status } ) => {
    const [ correct, setCorrect ] = useState( null );
    const { localization: { content } } = useSelector( ( state ) => state );

    useEffect( () => {
        if ( status ) {
            setCorrect(
                <div className={ styles.correct }>
                    <h4 className={ styles.title }>{ content.quiz.editor.correct }</h4>
                </div>
            );
            setEventSound( { events: 'correct' } );

        } else if ( status === false ) {
            setCorrect(
                <div className={ styles.wrong }>
                    <h4 className={ styles.title }>{ content.quiz.editor.wrong }</h4>
                </div>
            );
            setEventSound( { events: 'wrong' } );
        }
    }, [] );

    return (
        <div className={ styles.wrapper }>
            { correct }
        </div>
    );
});

export default CorrectStatus;